import React from 'react';
import VideoBG from '../../assets/Video/19849-306108554.mp4';

export const HeroHome = () => {
  return (
    <section className="HeroSection bg-white overflow-hidden w-full pt-[80px] sm:pt-[100px] md:pt-[113px]">
      <div className="relative w-full h-[500px] sm:h-[650px] md:h-[750px] lg:h-[850px] xl:h-[900px] 4xl:h-[1100px] flex items-center justify-center">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover absolute inset-0"
          style={{ aspectRatio: '16 / 9', maxHeight: '100%' }}
        >
          <source src={VideoBG} type="video/mp4" loading="lazy" />
          Your browser does not support the video tag.
        </video>

        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(245deg, rgba(182, 28, 28, 0) 23.99%, #000 99.36%)',
            mixBlendMode: 'multiply',
          }}
        />

        {/* Centered Text */}
        <div className="relative z-20 text-center px-4 w-full max-w-[90vw] sm:max-w-[600px] md:max-w-[700px] 4xl:max-w-[1200px]">
          <h1 className="text-white font-bold leading-tight text-3xl sm:text-4xl md:text-6xl lg:text-[72px]">
            Contact <span className="text-[#5bc0fe]">Us</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroHome;
